interface IBaseProto {
    toMoney: () => number;
    fromMoney: () => any;
    formatMoney: () => string;
    formatMoneyComma: () => string;

    isNumber: () => boolean;

    getUuid: () => string;
}

interface IBaseArray {
    sortBy: (field?: string) => any[];
    unique: (field?: string) => any[];
}

declare global {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface String extends IBaseProto {}

    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface Number extends IBaseProto {}
    // new Intl.NumberFormat('uk-UA', {style: 'currency', currency: 'UAH' }).format(1854.4)

    // eslint-disable-next-line
    interface Array<T> extends IBaseArray {}
}

const formatNumber = (value: string) => {
    const arr = Array.from(Number(value).toFixed(2));
    arr.splice(-9, 0, ' ');
    arr.splice(-6, 0, ' ');

    return arr.join('').trim();
};
/* const formatMoney = (money, showCurrency = true) => {
    let formatted = new Intl.NumberFormat('uk-UA', { style: 'currency', currency: 'UAH' }).format(money)

    if (!showCurrency) {
        formatted = formatted.replace(/\sгрн\./, '');
    }

    return formatted;
}; */

// eslint-disable-next-line no-extend-native
String.prototype.toMoney = Number.prototype.toMoney = function (): any {
    const val = Number(this);
    return val ? +(val / 100).toFixed(2) : this;
};

// eslint-disable-next-line no-extend-native
String.prototype.fromMoney = Number.prototype.fromMoney = function (): number {
    const val = Number(this);
    return val ? Math.round(val * 100) : Number(this);
};

// eslint-disable-next-line no-extend-native
String.prototype.formatMoney = Number.prototype.formatMoney = function (): any {
    return formatNumber(this + '');
};

// eslint-disable-next-line no-extend-native
String.prototype.formatMoneyComma = Number.prototype.formatMoneyComma = function (): any {
    return formatNumber(this?.toMoney() + '').replace('.', ',');
};

// eslint-disable-next-line no-extend-native
Array.prototype.sortBy = function (field = 'id'): any[] {
    return this.sort((a, b) => {
        if (a[field] > b[field]) {
            return 1;
        } else if (a[field] < b[field]) {
            return -1;
        }
        return 0;
    });
};
// eslint-disable-next-line no-extend-native
Array.prototype.unique = function (field = 'id') {
    const arr = this.concat();
    for (let i = 0; i < arr.length; ++i) {
        for (let j = i + 1; j < arr.length; ++j) {
            if (arr[i][field] === arr[j][field]) {
                arr.splice(j--, 1);
            }
        }
    }
    return arr;
};

// eslint-disable-next-line no-extend-native
String.prototype.isNumber = Number.prototype.isNumber = function (): boolean {
    return typeof this === 'number';
};

// eslint-disable-next-line no-extend-native
String.prototype.getUuid = function (): any {
    return Math.random().toString().slice(2);
};

export function debounce(func, wait: number, immediate?) {
    let timeout;
    return function (...args: any[]) {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export const getRandomInt = (min: number, max: number): number => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

export {};
